import { useAuth } from "@/lib/auth-context";
import { lazy, Suspense } from "react";
import { DashboardSkeleton } from "@/components/dashboard-skeleton";

const ParentDashboard = lazy(() => import("@/features/parent-dashboard").then(m => ({ default: m.ParentDashboard })));
const StudentDashboard = lazy(() => import("@/features/student-dashboard").then(m => ({ default: m.StudentDashboard })));
const SchoolAdminDashboard = lazy(() => import("@/features/school-admin-dashboard").then(m => ({ default: m.SchoolAdminDashboard })));
const MerchantDashboard = lazy(() => import("@/features/merchant-dashboard").then(m => ({ default: m.MerchantDashboard })));
const SuperadminDashboard = lazy(() => import("@/features/superadmin-dashboard").then(m => ({ default: m.SuperadminDashboard })));
const FinanceOfficerDashboard = lazy(() => import("@/features/finance-officer-dashboard").then(m => ({ default: m.FinanceOfficerDashboard })));

export function AppPage() {
  const { user, profile, loading } = useAuth();

  if (loading) {
    return <DashboardSkeleton />;
  }

  if (!user) {
    if (typeof window !== "undefined") {
      window.location.replace("/auth");
    }
    return <DashboardSkeleton />;
  }

  const role = profile?.role ?? "parent";

  const dashboard = (
    <Suspense fallback={<DashboardSkeleton />}>
      {role === "student" && <StudentDashboard />}
      {role === "school_admin" && <SchoolAdminDashboard />}
      {role === "merchant" && <MerchantDashboard />}
      {role === "superadmin" && <SuperadminDashboard />}
      {role === "finance_officer" && <FinanceOfficerDashboard />}
      {role === "parent" && <ParentDashboard />}
    </Suspense>
  );
  return dashboard;
}
